"use client";

import { c as _c } from "react/compiler-runtime";
import { Textarea as HeroTextarea } from "@heroui/react";
import { cn } from "../../lib/utils";
export const Textarea = t0 => {
  const $ = _c(23);
  let className;
  let classNames;
  let props;
  let size;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      classNames,
      variant,
      size,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = classNames;
    $[3] = props;
    $[4] = size;
    $[5] = variant;
  } else {
    className = $[1];
    classNames = $[2];
    props = $[3];
    size = $[4];
    variant = $[5];
  }
  const t1 = size !== "lg" && "text-base sm:text-sm";
  const t2 = classNames?.input;
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = cn("placeholder:text-text-interactive-neutral-faint", t1, t2);
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = variant === "bordered" && "border-1 border-border-interactive-neutral-default shadow-none data-[hover=true]:border-border-interactive-neutral-hover group-data-[focus-within=true]:border-border-interactive-neutral-selected group-data-[focus-within=true]:data-[hover=true]:border-border-interactive-neutral-selected";
  const t5 = variant !== "bordered" && "bg-default-100";
  const t6 = classNames?.inputWrapper;
  let t7;
  if ($[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
    t7 = cn(t4, t5, t6);
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== classNames || $[14] !== t3 || $[15] !== t7) {
    t8 = {
      ...classNames,
      input: t3,
      inputWrapper: t7
    };
    $[13] = classNames;
    $[14] = t3;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== className || $[18] !== props || $[19] !== size || $[20] !== t8 || $[21] !== variant) {
    t9 = <HeroTextarea radius="sm" className={className} variant={variant} size={size} classNames={t8} {...props} />;
    $[17] = className;
    $[18] = props;
    $[19] = size;
    $[20] = t8;
    $[21] = variant;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};